<template>
  <div class="row">
    <div class="col-sm-6">
      <card class="stacked-form">
        <form @submit.prevent="submit">
          <fg-input label="Name"
            type="text"
            v-model="user.name"
            :error="valErrors['name'] ? valErrors['name'][0] : null"
          />
          <fg-input label="Anzeigename (kurz)"
            type="text"
            v-model="user.short_name"
            :error="valErrors['short_name'] ? valErrors['short_name'][0] : null"
          />
          <fg-input label="Email"
            type="email"
            v-model="user.email"
            :error="valErrors['email'] ? valErrors['email'][0] : null"
          />
          <fg-input label="Telefonnummer"
            type="text"
            v-model="user.phone"
            :error="valErrors['phone'] ? valErrors['phone'][0] : null"
          />
          <template v-if="warehouses.length > 1">
            <div class="form-group has-label">
              <label>Standardlager</label>
              <multiselect v-model="user.warehouse"
                :options="warehouses"
                track-by="id"
                label="short_name"
                placeholder="Lager auswählen"
              />
            </div>
          </template>
          <div class="form-group has-label">
            <label>Rolle</label>
            <multiselect v-model="user.role" :options="roles" :allow-empty="false" deselect-label=""/>
          </div>
          <button type="submit" class="btn btn-fill btn-info">Speichern</button>
        </form>
      </card>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      roles: ['frontdesk', 'user', 'lageradmin', 'admin'],
      user: {},
      valErrors: [],
      warehouses: []
    }
  },
  methods: {
    async submit () {
      await this.initCsrf()

      this.valErrors = []
      this.user.warehouse_id = this.user.warehouse ? this.user.warehouse.id : null
      this.$http.put(`/users/${this.user.id}`, this.user).then(({ data }) => {
        this.$notify({
          message: 'User erfolgreich bearbeitet.',
          type: 'success'
        })
        this.$router.push('/users')
      }).catch(({ response }) => {
        this.valErrors = response.data.errors
      })
    }
  },
  created () {
    this.$http.get(`/users/${this.$route.params.id}`).then(({ data }) => {
      this.user = data
    })
    this.$http.get(`/warehouses`).then(({ data }) => { this.warehouses = data })
  }
}
</script>

<style>
</style>
